<template>
  <fb-list-body
    :pager="pager"
    v-loading="loading"
    :showBtnGroup="true"
    :showSearchForm="true"
    @handlePagerSizeChange="handlePagerSizeChange"
    @handlePagerIndexChange="handlePagerIndexChange"
  >
    <template slot="btn-group">
      <el-button @click="handleBatchUpdate">{{ $t('lang.设为在线食谱') }}</el-button>
      <el-button @click.native="cancelBatchUpdate">{{ $t('lang.取消') }}</el-button>
    </template>
    <!-- 食谱分类 -->
    <template slot="search-form">
      <el-form-item :label="$t('lang.语言分类')">
        <el-select clearable v-model="searchForm.lang">
          <el-option v-for="item in supportLangList" :key="item.value" :value="item.value" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.分类')">
        <el-select v-model="searchForm.recipeCategoryCode" :placeholder="$t('lang.请选择')" clearable>
          <el-option v-for="item in categoryList" :key="item.code" :label="item.name" :value="item.recipeCategoryCode"  />
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.标签')">
        <el-select v-model="searchForm.tag" clearable>
          <el-option v-for="item in recipeTagList" :key="item.recipeTagCode" :label="item.name" :value="item.name" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.食谱名称')">
        <el-input v-model="searchForm.name" clearable />
      </el-form-item>

      <el-form-item :label="$t('lang.食谱编号')">
        <el-input v-model="searchForm.number" clearable />
      </el-form-item>

      <el-form-item :label="$t('lang.是否在线食谱')">
        <el-select v-model="searchForm.onlineStatus" clearable>
          <el-option value="online" :label="$t('lang.是')" />
          <el-option value="offline" :label="$t('lang.否')" />
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱类型')">
        <el-select v-model="searchForm.type" clearable>
          <el-option :value="value" :label="$t(`lang.${key}`)" v-for="(key, value, index) in $dict.RECIPE_TYPE" :key="index" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.按型号筛选')">
        <el-select v-model="searchForm.productCodes" clearable :placeholder="$t('lang.请选择')">
          <el-option v-for="i in productList" :key="i.productCode" :label="i.productModel" :value="i.productCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" type="primary" @click="handleReset">{{$t('lang.重置')}}</el-button>
      </el-form-item>

    </template>

    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column :label="$t('lang.图片')">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.photo | filterImg"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱名称')">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.onlineStatus != 'online' ? '' : '#42bd83'
              }"
              >{{ scope.row.name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱编号')">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.onlineStatus != 'online' ? '' : '#42bd83'
              }"
              >{{ scope.row.number }}</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱版本号')">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.onlineStatus != 'online' ? '' : '#42bd83'
              }"
              >{{ scope.row.modifyEdition }}</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.支持型号')">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.onlineStatus != 'online' ? '' : '#42bd83'
              }"
              >{{ scope.row.productModels | join1 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.是否在线食谱')">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.onlineStatus != 'online' ? '' : '#42bd83'
              }"
              >{{ scope.row.onlineStatus != "online" ? $t('lang.否') : $t('lang.是') }}</span
            >
          </template>
        </el-table-column>

        <el-table-column :label="$t('lang.标签')" prop="tags"></el-table-column>
        <el-table-column :label="$t('lang.食谱类型')" prop="type">
          <template v-slot="{row}">
            {{ row.type | recipeType(that) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.支持型号')">
          <template v-slot="scope">
            <span>{{ scope.row.productModels | filterProduct }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱语言')">
          <template v-slot="{row}">
            <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled />
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="360">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.onlineStatus !== 'online'"
              @click="handleUpdate(scope.row)"
              plain
              type="primary"
              >{{ $t('lang.设为在线食谱') }}</el-button
            >
            <el-button
              size="mini"
              v-else
              @click="cancelUpdate(scope.row.code)"
              plain
              type="danger"
              >{{ $t('lang.取消') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
  </fb-list-body>
</template>

<script>
import {loadBrandOwnerProduct, loadSysSupportLang, recipeCategoryList, recipeTagList} from "../../js/common";
import NationList from "../../components/nation/NationList";

export default {
  name: "OnlineRecipeList",
  components: {NationList},
  props: {
    timestamp: {
      type: Number,
      default: function() {
        return new Date().getTime();
      }
    }
  },
  filters: {
    join1(data) {
      if (data) {
        return data.join(" / ");
      } else {
        return "";
      }
    },
    filterProduct(list) {
      if (Array.isArray(list)) {
        return list.join('/');
      }
      return ''
    }
  },
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        batchUpdateOnlineStatus: this.$api.recipe.batchUpdateOnlineStatus,
      },
      searchForm: {
        recipeCategoryCode: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 1
      },
      recipeCategoryList: [],
      recipeTagList: [],
      loading: false,
      that: this,
      productList: []

    };
  },
  computed: {
    searchParams() {
      return Object.assign({
        status: 'released',
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
      }, this.$route.query, this.searchForm, this.pager);
    },
    supportLangList() {
      return this.$store.state.supportLangList;
    },
    categoryList() {
      let list = this.recipeCategoryList;
      if(!this.searchForm.lang) return list;
      return list.filter(item => item.lang === this.searchForm.lang);
    }
  },
  watch: {
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch(); // 这个直接调用了、
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true
    }
  },
  methods: {
    handleScreen() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleSearch();
    },

    handleEdit(e) {
      if (e && e.code) {
        this.$router.push({ path: "edit", query: { code: e.code } });
        return;
      }

      if (!this.selection.length) {
        this.$message({ type: "warning", message: this.$t('lang.未选择记录') });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({ type: "warning", message: this.$t('lang.一次只能编辑一条数据') });
        return;
      }

      this.$router.push({
        path: "edit",
        query: { code: this.selection[0].code }
      });
    },

    handleUpdate(row) {
      let vm = this;
      let data = {
        onlineStatus: row.onlineStatus !== "online" ? "online" : "offline",
        recipeCodeList: [row.code]
      };
      vm.$http.post(vm.api.batchUpdateOnlineStatus, data).then(resp => {
        if (resp.data.status === 200) {
          vm.$message({ type: "success", message: resp.data.desc });
          vm.handleSearch();
        } else {
          vm.$message({ type: "error", message: resp.data.desc });
        }
      });
    },
    cancelUpdate(code) {
      let vm = this;
      vm.$http
        .post(vm.api.batchUpdateOnlineStatus, {
          onlineStatus: "offline",
          recipeCodeList: [code]
        })
        .then(resp => {
          if (resp.data.status === 200) {
            vm.$message({ type: "success", message: resp.data.desc });
            vm.handleSearch();
          } else {
            vm.$message({ type: "error", message: resp.data.desc });
          }
        });
    },
    handleBatchUpdate() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({ type: "warning", message: vm.$t('lang.未选择记录') });
        return;
      }

      let codes = [];

      this.selection.forEach(e => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行批量设置在线食谱操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      })
        .then(() => {
          vm.$http
            .post(this.api.batchUpdateOnlineStatus, {
              onlineStatus: "online",
              recipeCodeList: codes
            })
            .then(resp => {
              if (resp.data.status === 200) {
                vm.$message({ type: "success", message: resp.data.desc });
                vm.handleSearch();
              } else {
                vm.$message({ type: "error", message: resp.data.desc });
              }
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    cancelBatchUpdate() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({ type: "warning", message: vm.$t('lang.未选择记录') });
        return;
      }

      let codes = [];

      this.selection.forEach(e => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行批量设置取消操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      })
        .then(() => {
          vm.$http
            .post(this.api.batchUpdateOnlineStatus, {
              onlineStatus: "offline",
              recipeCodeList: codes
            })
            .then(resp => {
              if (resp.data.status === 200) {
                vm.$message({ type: "success", message: resp.data.desc });
                vm.handleSearch();
              } else {
                vm.$message({ type: "error", message: resp.data.desc });
              }
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageIndex = 1;
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      this.loading = true;
      let params = {
        brandOwnerCode: this.searchParams.brandOwnerCode,
        ...this.searchParams
      }
      if(!params["recipeCategoryCode"]) delete params["recipeCategoryCode"];
      this.$http.post(this.api.list, this.$qs.stringify(params)).then(resp => {
          vm.loading = false;
          for (let key in resp.data.data) {
            if (resp.data.data[key] instanceof Array) {
              vm.tableData = resp.data.data[key];
            }
          }
          //处理分页
          vm.pager.itemCount = resp.data.data.pager.itemCount;
          vm.pager.pageIndex = resp.data.data.pager.pageIndex;
          vm.pager.pageSize = resp.data.data.pager.pageSize;
          vm.handleScrollTop();
        }).catch(() => {
          vm.loading = false;
          vm.$message.error("获取数据失败");
      });
    },

    handleScrollTop() {
      let el = document.getElementsByClassName("scroller")[1];
      el.scrollTop = 0;
    },

    handleReset() {
      if (Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.handleSearch();
      }
    }
  },
  async created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
    loadSysSupportLang(this);
    this.recipeTagList = await recipeTagList(this);
    this.recipeCategoryList = await recipeCategoryList(this);
    this.productList = await loadBrandOwnerProduct(this, this.$store.state.userInfo['brandOwnerCode']);

  }
};
</script>

<style scoped>

.dialog-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.#42bd83 {
  color: #42bd83;
}

/deep/ .el-radio-button__inner {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 8px;
}

</style>
